export default "__VITE_ASSET__xcJVABGx__"